module.exports = __webpack_public_path__ + "media/images/ssl-checkout-ba0a8b0e5dd62ea7fec39cb2fc5d72d3.png";